import { render, staticRenderFns } from "./view.html?vue&type=template&id=080a244a&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=080a244a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080a244a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('080a244a')) {
      api.createRecord('080a244a', component.options)
    } else {
      api.reload('080a244a', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=080a244a&scoped=true&", function () {
      api.rerender('080a244a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/interactive_panel/index.vue"
export default component.exports